<template>

    <div v-if="loading">
        loading division options...
    </div>
    <FormItem v-else :name="'Division:'">
        <select v-model="selected" :disabled="props.disabled">
            <option disabled value="">Choose something</option>
            <option v-for="item in options" :key="item.id" :value="item">
                {{ item.name }}
            </option>
        </select>
    </FormItem>
  

  <div class="debug">
        <p>selected vmodel = {{ selected }}</p>
        <p>division options all = {{ options }} </p>
        <p>division display options all = {{ displayOptions }} </p>
    </div>

</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue';
import  FormItem  from '@/components/form/Form-item.vue';
import { useProjectStore } from '@/stores/project-store';
import { storeToRefs } from 'pinia';

const projectStore = useProjectStore();
const { loading } = storeToRefs(projectStore);

const props = defineProps({
    disabled : { type : Boolean, default : false}
})

type Division ={
    id : number
    name: string
}

const divisions = ref<Division[]>([]);

onBeforeMount(async()=>{
    divisions.value = await projectStore.fetchDivisions();
})

const options = computed(()=>{
    return divisions.value.map(division =>{
        //return division.id;
        return division;
    })
})

const displayOptions = computed(()=>{
    return divisions.value.map(division =>{
        return division.name;
    })
})

const selected = defineModel('selected');//('selected');

</script>

